import {useCallback, useContext} from "react";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "./useCountryAxiosInstance";

const useFetchServiceChecklists = (serviceId, pageSize=null) => {
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  return useCallback(
    async (search=null, page=null, sortMode='asc', activeOnly=false, includeItems=false) => {

      // build request params
      const params = {id_service: serviceId};
      if (!!search) {
        params['des_title'] = search;
        params['des_description'] = search;
        params['like'] = 'des_title,des_description';
      }
      if (!!sortMode) {
        params[sortMode] = 'created_at';
      }
      if ((!!page || page === 0) && !!pageSize) {
        params['skip'] = page * pageSize;
        params['limit'] = pageSize;
      }
      if (!!activeOnly) {
        params['flg_active'] = true;
      }
      // retrieve checklists
      const checklists = await countryApiRequest.get(`/services_checklists`, {params});
      // retrieve checklists activities (if requested)
      if (checklists.length && includeItems) {
        const params = {asc: "val_order"};
        const items = await countryApiRequest.get(
          `/services_checklists_items/by_checklists_ids/${checklists.map((c) => c.id).join(',')}`,
          {params}
        );
        checklists.forEach((c, idx, arr) => {
          arr[idx] = {
            ...c,
            items: items
              .filter((a) => a.id_checklist === c.id)
              .sort((a, b) => a.val_order > b.val_order ? 1 : (a.val_order < b.val_order ? -1 : 0))
          };
        })
      }

      // get total number of records (useful for pagination)
      const totalParams = {id_service: serviceId};
      if (!!activeOnly)
        params['flg_active'] = true;
      const total = await countryApiRequest.get(`/services_checklists/count`, {params: totalParams});

      return {
        rows: checklists,
        total: total
      };
    },
    [serviceId, pageSize, countryApiRequest],
  );
}

export default useFetchServiceChecklists;